import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PlayersService} from "../../../services/players.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {
  PlayerStatsModalContentComponent
} from "../../player-stats-modal/player-stats-modal-content/player-stats-modal-content.component";
import {size} from "lodash";

@Component({
  selector: 'app-players-page-table',
  templateUrl: './players-page-table.component.html',
  styleUrls: ['./players-page-table.component.scss']
})
export class PlayersPageTableComponent implements OnInit {
  @Input() playersList: Array<any>;
  @Input() isDescendingOrder: boolean;
  @Input() Order: string;

  @Output() clickedHeader = new EventEmitter();

  public dictOfOrders = {
    ascending: 'asc',
    descending: 'desc',
  };

  private titlesDict = {
    '3un': '3юн',
    '2un': '2юн',
    '1un': '1юн',
    '1': 'I',
    '2': 'II',
    '3': 'III',
    'kms': 'КМС',
    'ms': 'МС',
    'msmk': 'МСМК',
    'zms': 'ЗМС',
    '-': '-',
  };

  private chooseColumn;


  private displayedColumnsId = [
    'avatar',
    'fullName',
    'birthYear',
    'title',
    'cityCountry',
    'playedDuels',
  ];

  private headerCellsIds = [
    'last_name',
    'birthdate',
    'calls',
    'city__region__country',
    'count_duel_series_list',
  ];

  constructor(
    private modalService: NgbModal,
    private playersService: PlayersService,
  ) { }

  ngOnInit(): void {
  }

  getPlayersList() {
    return this.playersList;
  }

  inputDataFormatter(primitiveData) {
    return primitiveData || '-';
  }

  getPlayerFullName(player) {
    return this.inputDataFormatter(player?.full_name);
  }

  getPlayerBirthYear(player) {
    const cutYear = player?.birthdate?.split('-')[0];
    return this.inputDataFormatter(cutYear);
  }

  getPlayerTitle(player) {
    return this.titlesDict[player?.title] || '-';
  }

  getPlayerCountryAndCity(player) {
    const cityObject = player.city;
    if (!cityObject) {
      return '-';
    }
    const countryName = cityObject.region?.country?.name;
    const cityName = cityObject?.name;

    if (!countryName) {
      return this.inputDataFormatter(cityName);
    } else if (!cityName) {
      return this.inputDataFormatter(countryName)
    }

    return `${countryName}, ${cityName}`;
  }

  getPlayerImage(player) {
    return player?.image || '/static/img/avatar/1.jpg';
  }

  getPlayerCountryCode(player) {
    return player?.city?.region?.country?.a2code || '';
  }

  getPlayedDuelsNumber(player) {
    return player.count_duel_series || '-';
  }
  getDisplayedColumns() {
    return this.displayedColumnsId;
  }

  setChooseColumn(value) {
    this.chooseColumn = value;
  }

  getChooseColumn() {
    return this.chooseColumn;
  }


  headerCellClickHandler(event) {
    const chooseTargetId = event.currentTarget.id;
    this.setChooseColumn(chooseTargetId);
    this.clickedHeader.emit(chooseTargetId);
  }

  getHeadersIds() {
    return this.headerCellsIds;
  }

  getPlayerId(player) {
    return player?.id;
  }

  playerFullNameClickHandler($event) {
    this.playersService.playerId = parseInt($event.target.id);
    const modalRef = this.modalService.open(PlayerStatsModalContentComponent, {
      size: 'lg',
    });
  }

}
